import { makeCustomIcon } from './utils';

export const dimEngramIcon = makeCustomIcon(
  'Engram',
  100,
  100,
  'M33.62 23.176h32.76l9.412-13.48L50 1.316l-25.79 8.38 9.41 13.48zm37.985 3.742l10.14 31.202 15.052 4.37V35.317L80.96 13.52l-9.354 13.398zM50 77.984l25.436-18.48-9.715-29.902H34.28l-9.715 29.903L50 77.985zm3.214 5.61v15.088l25.71-8.353 15.8-21.75L79.83 64.25 53.21 83.59zm-6.427 0L20.172 64.256 5.278 68.58l15.8 21.75 25.71 8.352V83.594zm-18.39-56.676l-9.357-13.4-15.836 21.8V62.49l15.053-4.37 10.14-31.202z'
);

export default dimEngramIcon;
